import { notFound } from '@tanstack/react-router';
import { getAppEnv } from '~portal/env';

/**
 * @desc The Automations section's `beforeLoad` (H2-7, task 8.1): where `VITE_AUTOMATIONS_ENABLED`
 * is unset it does not exist — `notFound()`, exactly as an unknown path, mirroring the Restricted
 * section's guard. The admin check is the admin layout's.
 *
 * No edge rule is added, unlike `/restricted/*`: the section sits under `/admin`, which the edge
 * already serves on the same terms as the rest of the admin panel (a shell that renders nothing
 * for a non-admin), and every procedure behind these pages is `AP` with `canAutomate` checked
 * again in the service — the authoritative gate.
 */
export function guardAutomationsSection(): void {
  if (!getAppEnv().automationsEnabled) throw notFound();
}
